export default __webpack_public_path__ + "static/media/clipboard.88c20563.svg";